import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { Trash2, AlertCircle } from 'lucide-react';

const DeleteVisitModal = ({ show, onHide, onConfirm, visitorName, visitDate, isDeleting }) => {
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");

    const handleConfirm = () => {
        if (!reason.trim()) {
            setError("Please provide a reason for deletion.");
            return;
        }
        onConfirm(reason);
        setReason("");
        setError("");
    };

    return (
        <Modal show={show} onHide={onHide} centered contentClassName="db1-modal-content">
            <div className="db1-modal-header d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                    <Trash2 size={22} />
                    <h5 className="mb-0 fw-bold">Confirm Deletion</h5>
                </div>
                <button onClick={onHide} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', borderRadius: '8px', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>✕</button>
            </div>
            <Modal.Body className="pt-4 px-4">
                <p className="mb-3" style={{ color: '#555', fontSize: '0.92rem' }}>
                    Are you sure you want to delete the visit record for <strong style={{ color: '#ac2e62' }}>{visitorName}</strong> on <strong>{visitDate}</strong>?
                </p>
                <div className="d-flex align-items-start gap-2 p-3" style={{ background: 'rgba(255, 193, 7, 0.06)', borderRadius: '12px', fontSize: '0.85rem', color: '#856404' }}>
                    <AlertCircle size={18} className="flex-shrink-0 mt-1" />
                    <div>
                        This action will soft-delete the visit record. It will no longer appear in logs or statistics, but an audit trail will be maintained.
                    </div>
                </div>
                <Form.Group className="mt-3">
                    <Form.Label className="fw-bold mb-1" style={{ color: '#2c3e50', fontSize: '0.85rem' }}>Reason for Deletion <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="e.g., Accidental duplicate entry, incorrect data entry, etc."
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value);
                            if (e.target.value.trim()) setError("");
                        }}
                        isInvalid={!!error}
                        autoFocus
                        style={{ borderRadius: '12px', border: '1px solid rgba(0,0,0,0.06)', fontSize: '0.88rem', padding: '12px', resize: 'none' }}
                    />
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0 px-4 pb-4">
                <Button 
                    variant="light" 
                    onClick={onHide} 
                    disabled={isDeleting}
                    style={{ borderRadius: '999px', padding: '8px 22px', fontWeight: 600, fontSize: '0.85rem', border: '1px solid rgba(0,0,0,0.06)' }}
                >
                    Cancel
                </Button>
                <Button 
                    variant="danger" 
                    onClick={handleConfirm}
                    disabled={isDeleting}
                    className="px-4 fw-bold"
                    style={{ borderRadius: '999px', padding: '8px 24px', fontSize: '0.85rem', fontWeight: 600, background: 'linear-gradient(135deg, #dc3545, #e05c6b)', border: 'none' }}
                >
                    {isDeleting ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Deleting...
                        </>
                    ) : (
                        "Delete Visit"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteVisitModal;
